
import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { AppComponent } from 'src/app/app.component';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from 'src/app/notification.service';
import { LeadSourceService } from 'src/app/shared/services/leadsource.services';
import { ConfirmDialogComponent } from 'src/app/shared/dialogs/confirm-dialog/confirm-dialog.component';
import { DialogData } from 'src/app/shared/models/dialogData';
import { TblLeadConditions } from '../shared/models/LeadConditions';
import { LeadConditionsService } from '../shared/services/leadconditionservice';
import { UserServices } from '../shared/services/userservices';
import { TblUser } from '../shared/models/user';
import { TblSource } from '../shared/models/source';
import { TblLeadSources } from '../shared/models/leadsources';
import { LocalStorageService } from '../utility/localStorageService';
import { PagerService } from '../shared/pagination';
import { EditLeadConditionDialogComponent } from './edit-lead-condition-dialog.component';

@Component({
  selector: 'app-lead-conditions',
  templateUrl: './lead-conditions.component.html',
  styleUrls: ['./lead-conditions.component.css']
})
export class LeadConditionsComponent implements OnInit {
  model: TblLeadConditions;
  dialogData: DialogData;
  members: Observable<TblLeadConditions[]>;
  users:Observable<TblUser[]>;
  sources:Observable<TblLeadSources[]>;
  modalRef: BsModalRef;
  editDataAvbl: boolean;
  userType: string;
  pager: any = {};
  private allItems: any[];
  pagedItems: any[];
  
  constructor(private leadConditionsService : LeadConditionsService,
    private modalService: BsModalService,
    private spinnerService: AppComponent ,
    private leadService:LeadSourceService,
    private pagerService: PagerService,
    private userService:UserServices,
    private localStorage:LocalStorageService,
    private dialog: MatDialog,
    private notifyService : NotificationService) {
  }

  ngOnInit(): void {
    this.userType = this.localStorage.get("userType")
    this.model=new TblLeadConditions();
    this.getAllData();
    this.getAllSOurces()
    this.getAllUsers()
    this.model.leadsAtATime="1"
  }
  getAllUsers()
  {
    this.users= this.userService.getAllUsers()
  }
  getAllSOurces()
  {
    this.sources=this.leadService.getAllLeadSource()
  }
  ngAfterViewInit() {
    //this.dt1.datetimeFormat = {"yyyy-mm-dd"};
  }
  getAllData(){
    //this.spinnerService.spinnerStatus(true);
    this.members= this.leadConditionsService.getAllLeadConditions();
    this.members.subscribe(data => {
      this.allItems = data || [];
      this.setPage(1);
    });
    //this.spinnerService.spinnerStatus(false);
  }

  setPage(page: number) {
    this.pager = this.pagerService.getPager(this.allItems.length, page, 5);
    this.pagedItems = this.allItems.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  openAddDialog() {
    const dialogRef = this.dialog.open(EditLeadConditionDialogComponent, {
      width: '600px',
      data: { isEditing: false, model: new TblLeadConditions() }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.action === 'save') {
        this.getAllData();
      }
    });
  }

  openEditDialog(id: any) {
    const dialogRef = this.dialog.open(EditLeadConditionDialogComponent, {
      width: '600px',
      data: { isEditing: true, id: id }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.action === 'save') {
        this.getAllData();
      }
    });
  }

  deleteData(id:any)
  {
    let modalConfig: any = { animated: true, keyboard: true, backdrop: true, ignoreBackdropClick: false };
    const initialState = {mode:'Delete',  module: 'Lead Condition', refNo:id};
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, modalConfig, { class: 'modal-sm', initialState }))
  }

  stopPropagation(event){
    event.stopPropagation();
  }
  
  searchTable() {
    var term, table;
    term=document.getElementById("myInput") as unknown as HTMLInputElement
    // get term to search
    term = term.value.toLowerCase();
    table =document.getElementById("myTable") as HTMLTableElement
    // get table rows, handle as array.
    table = Array.from(table.rows);

    // filter non-matching rows; these are set to display='none'
    table.filter(function(el) {
        return el.textContent.toLowerCase().indexOf(term) ==
            -1
    }).map(x => x.style.display = "none");

    // filter matching rows; these are set to display =''
    table.filter(function(el) {
        return el.textContent.toLowerCase().indexOf(term) > -1
    }).map(x => x.style.display = "");
}
}
